import { useQuery } from '@tanstack/react-query'
import { currencyApi } from '@wtf/shared/api/currency'

/**
 * Hook to fetch currency exchange rates
 * Rates are cached for 1 hour on the client side
 */
export function useCurrencyRates() {
    return useQuery({
        queryKey: ['currency', 'rates'],
        queryFn: () => currencyApi.getCurrencyRates(),
        staleTime: 60 * 60 * 1000, // 1 hour
        gcTime: 24 * 60 * 60 * 1000, // 24 hours (formerly cacheTime)
    })
}
